import { adminPageList } from '@admin/admin.constants';
import { useBreakPoints } from '@common/breakpoints.hooks';
import { identifyUser } from '@common/dynatrace.services';
import { useAppConfigs, useHasPermission } from '@config/config.hooks';
import { envConfigs } from '@config/envConfigs';
import {
  AzureLoginLogoutButton,
  ILoggedInUser,
  Grid,
  Icon,
  Avatar,
  Button,
  ComponentType,
  DropdownButton,
} from '@gcl/react-core';
import { useReportList } from '@report/report.hooks';
import { useNavigate } from '@routes/routes.hooks';
import { routes } from '@routes/routes.models';
import { EPermission } from '@userProfile/permission/permission.constants';
import { ReactElement, useMemo } from 'react';
import { AnnouncementUnreadBadge } from './AnnouncementUnreadBadge';

interface ITopNavBar {
  closeNav?: () => void;
}
export const TopNavBar = ({ closeNav }: ITopNavBar) => {
  const { navigate, generateRoutePath } = useNavigate();
  const appConfigs = useAppConfigs();
  const { isXs } = useBreakPoints();
  const isWebMaster = useHasPermission(EPermission.WEB_MASTER);
  const reportList = useReportList();

  const adminList: ReactElement[] = useMemo(() => {
    return adminPageList.map((item) => {
      return (
        <div
          key={`top-nav-admin-list-${item.pageType}`}
          onClick={() => {
            navigate(routes.admin.item.path, { type: item.pageType }, false);
          }}
        >
          {item.pageName}
        </div>
      );
    });
  }, [JSON.stringify(adminPageList)]);

  const onClickAvatar = () => {
    if (closeNav) closeNav();
    navigate(routes.userProfile.path);
  };

  return (
    <div className={`${isXs ? 'gcl-gems-top-nav-container-mobile' : 'gcl-gems-top-nav-container'}`}>
      <AzureLoginLogoutButton
        scopes={[envConfigs.apiScope as string]}
        onUserLoggedIn={(user: ILoggedInUser) => {
          appConfigs.updateConfigs?.((configs) => {
            return { ...configs, loggedInUser: user };
          });
          identifyUser(user.username || '');
        }}
        validateIssuers={(issuer) => {
          // if (!envConfigs?.validIssuers) return true;
          // return envConfigs.validIssuers.split(',').some((validIssuer) => {
          //   // issuer format 'https://login.microsoftonline.com/{tenantId}/v2.0
          //   return issuer.includes(validIssuer);
          // });
          return true;
        }}
        render={(isLoggedIn, onClickLoginLogoutBtn, accounInfo, imageSrc) => {
          return (
            <>
              {/* {isLoggedIn && !isXs && (
                <TextField
                  prefixLabel={{ prefixIconName: 'Search' }}
                  onChange={(newValue: string | number | undefined) => {}}
                  placeholder="Search"
                />
              )} */}
              {!isXs && (
                <div className="gcl-gems-layout-top-nav-logo">
                  <img alt="gammon-logo" src="https://logo.gammonconstruction.com/Icon_R.png" className="gcl-mr-sm" />
                  <img alt="gems-logo" src="/images/gems-logo.png" width="auto" />
                </div>
              )}
              <Grid
                flexDirection="row"
                justifyContent="flex-end"
                container
                alignItems="center"
                className={`gcl-gems-layout-top-nav-grid ${
                  appConfigs.configs.isDetailPageDrawerOpen ? 'gcl-gems-layout-right-nav-opened' : ''
                }`}
              >
                {isLoggedIn ? (
                  <>
                    {!isXs && (
                      <>
                        <div
                          className="gcl-gems-layout-link"
                          onClick={() => {
                            window.open('https://srms.gammonconstruction.com/#/inquiry/GEMS/GEMS', '_blank');
                          }}
                        >
                          Report Issue
                        </div>
                        <div
                          className="gcl-gems-layout-link"
                          onClick={() => {
                            navigate(routes.announcement.list.path);
                          }}
                        >
                          <AnnouncementUnreadBadge />
                          Announcement
                        </div>
                        <div
                          className="gcl-gems-layout-link"
                          onClick={() => {
                            navigate(routes.projectList.path);
                          }}
                        >
                          Change Project
                        </div>
                        <div
                          className="gcl-gems-layout-link"
                          onClick={() => {
                            navigate(routes.myGems.path);
                          }}
                        >
                          My GEMS
                        </div>

                        <div
                          className="gcl-gems-layout-link"
                          onClick={() => {
                            window.open('https://mobile-app.gammonconstruction.com/AppStore/#/appStore', '_blank');
                          }}
                        >
                          Mobile App
                        </div>
                        {reportList.length > 0 && (
                          <DropdownButton
                            className="gcl-gems-layout-dropdown-btn"
                            type={ComponentType.Light}
                            mainButtonContent="Reports"
                            dropdownItems={reportList.map((r) => {
                              return (
                                <div
                                  key={`top-nav-report-list-${r.type}`}
                                  onClick={() => navigate(r.route, undefined, false)}
                                >
                                  {r.name}
                                </div>
                              );
                            })}
                          />
                        )}

                        {isWebMaster && (
                          <DropdownButton
                            className="gcl-gems-layout-dropdown-btn"
                            type={ComponentType.Light}
                            mainButtonContent="Admin"
                            dropdownItems={adminList}
                          />
                        )}
                      </>
                    )}
                    <div>
                      <div className="gcl-gems-layout-setting">
                        <Icon iconName="GearFill" className="gcl-gems-layout-setting-icon" />
                        <Avatar
                          className="gcl-clickable "
                          onClick={onClickAvatar}
                          round
                          name={accounInfo?.name || ''}
                          maxInitials={1}
                          size="28"
                          src={imageSrc}
                        />
                      </div>
                    </div>

                    <div>
                      <Icon
                        iconName="BoxArrowRight"
                        className="gcl-clickable  "
                        size={20}
                        onClick={() => {
                          if (closeNav) closeNav();
                          onClickLoginLogoutBtn();
                        }}
                      />
                    </div>
                  </>
                ) : (
                  <Button
                    style={{ margin: '0 auto 10px auto' }}
                    className="gcl-clickable"
                    onClick={onClickLoginLogoutBtn}
                    type={ComponentType.Primary}
                    prefixIconName="Microsoft"
                  >
                    <span>Sign In</span>
                  </Button>
                )}
              </Grid>
            </>
          );
        }}
      />
    </div>
  );
};
